import {
    addToSelection,
    clearSelection,
    removeFromSelection,
} from '../reducers';

import {selectionSelector} from '../selectors';
import {
    useAppDispatch,
    useAppSelector
} from '../../../hooks/useTypedReactRedux';

import {useRegistrarsQuery} from './useRegistrarsQuery';
import {Registrar} from '../types';


export const useRegistrarsSelection = () => {
    const dispatch = useAppDispatch();

    const selection = useAppSelector((state) => selectionSelector(state));

    // FNP-943: select-all iterates the records React Query fetched.
    const {data} = useRegistrarsQuery();
    const items = data ?? [];


    // SELECTION
    const handleRowSelection = (row: { id: string }) => {
        if (typeof selection[row.id] !== 'undefined') {
            dispatch(removeFromSelection(row.id));
        } else {
            dispatch(addToSelection(row));
        }
    };

    const handleSelectAllRows = () => {
        for (let i = 0; i < items.length; i++) {
            if (typeof selection[items[i].id] !== 'undefined') {
                dispatch(removeFromSelection(items[i].id));
            } else {
                dispatch(addToSelection(items[i]));
            }
        }
    };

    const handleClearSelection = () => {
        dispatch(clearSelection());
    };

    // FNP-1292 — THE BRIDGE TO `MantineDataTable`.
    //
    // Selection stays in the REDUX SLICE (§3, FNP-951) — that is the platform
    // standard and this module already had it. `mantine-datatable` speaks a
    // `Registrar[]` of selected rows instead of the slice's id-keyed map, so
    // the two shapes are reconciled here rather than by replacing the slice
    // with the module-level singleton the checklist names as an anti-pattern.
    const selectedRecords: Registrar[] = Object.values(selection) as Registrar[];

    const setSelectedRecords = (records: Registrar[]) => {
        const nextIds = new Set(records.map(record => record.id));
        // Added rows.
        records.forEach(record => {
            if (typeof selection[record.id] === 'undefined') {
                dispatch(addToSelection(record));
            }
        });
        // Removed rows.
        Object.keys(selection)
              .forEach(id => {
                  if (!nextIds.has(id)) {
                      dispatch(removeFromSelection(id));
                  }
              });
    };

    return {
        items,
        selection,
        selectedRecords,
        setSelectedRecords,
        handleRowSelection,
        handleSelectAllRows,
        handleClearSelection,
    };
};
